export default __webpack_public_path__ + "static/media/192.5cca1d70.jpg";